import { useState, useRef, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import defaultLanguage from 'i18n/defaultLanguage';

import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as Api from 'api';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Chip,
  ClickAwayListener,
  Divider,
  Grid,
  InputAdornment,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  OutlinedInput,
  Paper,
  Popper,
  Stack,
  Switch,
  Typography,
  Dialog
} from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import language from '../../../../assets/images/icons/language.svg';
// project imports
import MainCard from 'ui-component/cards/MainCard';
import Transitions from 'ui-component/extended/Transitions';
import UpgradePlanCard from './UpgradePlanCard';
import User1 from 'assets/images/users/user-round.svg';
import Subscribe from 'assets/images/subscribe_pop.png';

// assets
import { IconLogout, IconSearch, IconSettings, IconUser } from '@tabler/icons';
import LanguageSection from './LanguageSection';
import TaskQueue from '../TaskQueue';
import useToast from 'hooks/useToast';
import { USERINFO } from 'store/actions';
import useUserinfo from "hooks/useUserinfo";

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const customization = useSelector((state) => state.customization);
  const navigate = useNavigate();
  const theme = useTheme();
  const [sdm, setSdm] = useState(true);
  const [value, setValue] = useState('');
  const [notification, setNotification] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [open, setOpen] = useState(false);
  const userinfo = useSelector((state) => state.userinfo);

  const [subscribeOpen, setSubscribeOpen] = useState(false);
  const toast = useToast();
  useUserinfo();

  /**
   * anchorRef is used on different componets and specifying one type leads to other components throwing an error
   * */
  const anchorRef = useRef(null);
  const handleLogout = async () => {
    const { code, msg } = await Api.logout().catch((e) => e);
    if (code === 0) {
      dispatch({ type: USERINFO, info: null });
      location.replace('/');
    } else {
      toast(msg || Api.ERROR_MESSAGE, { variant: 'error' });
    }
  };

  const handlesubscribe = (event) => {
    toast('正在玩命施工中～', { variant: 'succeed' });
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleListItemClick = (event, index, route = '') => {
    setSelectedIndex(index);
    handleClose(event);

    if (route && route !== '') {
      navigate(route);
    }
  };
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const prevOpen = useRef(open);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <TaskQueue />
      <ButtonGroup variant="text" aria-label="text button group">
        <Button>
          <Typography
            sx={{
              color: '#DAAF19',
              borderStyle: 'solid',
              borderWidth: '1px',
              borderColor: '#DBBC42',
              p: 1,
              mr: 1,
              fontWeight: 10,
              borderRadius: '5px'
            }}
          >
            <Trans i18nKey="toolbar.coin">{defaultLanguage.toolbar.coin}</Trans>: {userinfo.points ? userinfo.points : '0'}
          </Typography>
        </Button>
        <Button>
          <img src={language} alt="language" width={24} height={24} sx={{ ml: 2 }} />
          <LanguageSection></LanguageSection>
        </Button>
        <Button onClick={() => setSubscribeOpen(true)}>
          <Typography
            sx={{
              color: '#4D4D4D',
              fontSize: 17,
              mr: 2,
              ml: 2
            }}
          >
            <Trans i18nKey="toolbar.purchase">{defaultLanguage.toolbar.purchase}</Trans>
          </Typography>
        </Button>
        <Button onClick={handleToggle}>
          <Avatar
            src="https://bkmk.oss-accelerate.aliyuncs.com/e17e95fa-b14b-11ed-b87a-00163e008cc0_00002.mid.jpg?OSSAccessKeyId=LTAI5tPynodLHeacT1J5SmWh&Expires=317036917502&Signature=nXoDIowvJlaqtk%2Fgh9eGE4uek78%3D"
            sx={{
              width: 40,
              height: 40,
              margin: '0px 0px 0px 0px !important',
              cursor: 'pointer'
            }}
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            color="inherit"
          />
          <Box
            sx={{
              ml: 1.2
            }}
          >
            <Typography sx={{ color: '#000000' }}>{userinfo.username ? userinfo.username : 'MaKaBaKa'}</Typography>
            <Chip
              sx={{
                height: '16px',
                mt: '2px',
                fontSize: 11,
                color: '#ffffff',
                backgroundImage: `linear-gradient(-90deg, #B561FF, #7D3CFF);`,
                float: 'left'
              }}
              label={userinfo.level ? `Lv` + userinfo.level : 'Lv1'}
            />
          </Box>
        </Button>
      </ButtonGroup>
      <Popper
        placement="bottom-start"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 14]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions in={open} {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                  <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(100vh - 250px)', overflowX: 'hidden' }}>
                    <Box>
                      <List
                        component="nav"
                        sx={{
                          width: '100%',
                          maxWidth: 240,
                          minWidth: 200,
                          borderRadius: '10px',
                          [theme.breakpoints.down('md')]: {
                            minWidth: '100%'
                          },
                          '& .MuiListItemButton-root': {
                            mt: 0.5
                          }
                        }}
                      >
                        <Link to={{ pathname: '/profile' }} style={{ textDecoration: 'none' }}>
                          <ListItemButton sx={{ borderRadius: `${customization.borderRadius}px` }} selected={selectedIndex === 0}>
                            <ListItemIcon>
                              <IconUser stroke={1.5} size="1.3rem" />
                            </ListItemIcon>
                            <ListItemText
                              primary={
                                <Typography variant="body2">
                                  <Trans i18nKey="toolbar.profile">{defaultLanguage.toolbar.profile}</Trans>
                                </Typography>
                              }
                            />
                          </ListItemButton>
                        </Link>

                        <ListItemButton
                          sx={{ borderRadius: `${customization.borderRadius}px` }}
                          selected={selectedIndex === 4}
                          onClick={handleLogout}
                        >
                          <ListItemIcon>
                            <IconLogout stroke={1.5} size="1.3rem" />
                          </ListItemIcon>
                          <ListItemText
                            primary={
                              <Typography variant="body2">
                                <Trans i18nKey="toolbar.logout">{defaultLanguage.toolbar.logout}</Trans>
                              </Typography>
                            }
                          />
                        </ListItemButton>
                      </List>
                    </Box>
                  </PerfectScrollbar>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
      <Dialog
        open={subscribeOpen}
        onClose={() => setSubscribeOpen(false)}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: '100%'
          }
        }}
      >
        <img position="absolute" width="800px" src={t('toolbar.dingyue')} alt={'Subscribe'} loading="lazy" />
      </Dialog>
    </>
  );
};

export default ProfileSection;
